import { withTranslations } from 'hooks/useTranslations'
import { graphql, useStaticQuery } from 'gatsby'
import ContactBox from './ContactBox'

declare global {
  interface Snippets {
    'app-contact-box': {
      app_contact_box_headline: void
      app_contact_box_description: {
        SERVICE_LINK: string
      }
      app_contact_box_customer_service_info: void
      app_contact_box_customer_service_agent: {
        AGENT_NAME: string
      }
    }
  }
}

export default withTranslations(ContactBox, () =>
  useStaticQuery(graphql`
    query app_contact_box_translationsq {
      app_contact_box_headline: snippet(
        group: "app-contact-box"
        name: "app_contact_box_headline"
      )
      app_contact_box_description: snippet(
        group: "app-contact-box"
        name: "app_contact_box_description"
      )
      app_contact_box_customer_service_info: snippet(
        group: "app-contact-box"
        name: "app_contact_box_customer_service_info"
      )
      app_contact_box_customer_service_agent: snippet(
        group: "app-contact-box"
        name: "app_contact_box_customer_service_agent"
      )
    }
  `)
)
